import * as React from "react";
const SvgFiRrToiletPaperBlank = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-toilet-paper-blank_svg__a)">
      <path
        fill="#062147"
        d="M19 0H8C5.196 0 3 3.294 3 7.5V17a1.99 1.99 0 0 1-1.259 1.858C.683 19.28 0 20.257 0 21.346a2.656 2.656 0 0 0 2.653 2.653H11c2.757 0 5-2.243 5-5v-2h3c2.804 0 5-3.733 5-8.5S21.804 0 19 0m-5 19c0 1.654-1.346 3-3 3H2.653A.654.654 0 0 1 2 21.347c0-.323.249-.538.483-.631A3.98 3.98 0 0 0 5 17V7.5C5 4.259 6.581 2 8 2h7.745C14.672 3.547 14 5.866 14 8.5zm5-4c-1.419 0-3-2.67-3-6.5S17.581 2 19 2s3 2.67 3 6.5-1.581 6.5-3 6.5m1-6.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5.448-1.5 1-1.5 1 .672 1 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-toilet-paper-blank_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToiletPaperBlank;
